import React from 'react'
import { string, bool } from 'prop-types'
import Logo from 'components/logo'
import { Button } from 'components'
import { connect } from 'react-redux'
import { GEORGE_NEEDHELP_URL, GROCERIES_NEEDHELP_URL, DOT_COM_URL, GIFTCARDS_ACCOUNT_URL } from 'services/utils/constants/site-urls'
import { getSourceLabel } from 'services/utils/constants/config-values'
import { isValidRedirectURI } from 'services/utils/helpers/redirect-uri'

const Header = ({
  isThirdParty, redirectUri, requestOrigin, isGeorgeUser,
  isBabyClubUser, isGiftCardUser, isCreditCardUser,
}) => {
  const goBackButtonClickHandler = () => {
    // When GiftCard user lands on account settings with only client_Id
    if (isGiftCardUser) window.open(GIFTCARDS_ACCOUNT_URL, '_self')
    else if (!isValidRedirectURI(redirectUri)) window.open(document.location.origin, '_self')
    else window.open(redirectUri, '_self')
  }
  return (
    <header>
      <div className="header-container">
        <Logo
          isThirdParty={isThirdParty}
          isGeorgeUser={isGeorgeUser}
          requestOrigin={requestOrigin}
          isCreditCardUser={isCreditCardUser}
          tabOrder={1}
        />
        <nav>
          {!isThirdParty && !isBabyClubUser ? (
            <Button
              className="basic need-help"
              type="button"
              id="need-help"
              tabOrder={2}
              onClick={() =>
              window.open(isGeorgeUser ? GEORGE_NEEDHELP_URL : GROCERIES_NEEDHELP_URL, '_blank')
            }
            >
              Need help?
            </Button>
        ) : null}
          {!isCreditCardUser && (
            <Button
              className="basic back-shop"
              type="button"
              id="back-shop"
              tabOrder={3}
              onClick={goBackButtonClickHandler}
            >
              {isThirdParty ? 'Go back' : getSourceLabel(requestOrigin)}
            </Button>
          )}
        </nav>
      </div>
    </header>
  )
}

Header.propTypes = {
  redirectUri: string,
  requestOrigin: string,
  isGeorgeUser: bool,
  isBabyClubUser: bool,
  isThirdParty: bool,
  isGiftCardUser: bool,
  isCreditCardUser: bool,
}

Header.defaultProps = {
  redirectUri: DOT_COM_URL,
  requestOrigin: 'asda',
  isGeorgeUser: false,
  isBabyClubUser: false,
  isThirdParty: false,
  isGiftCardUser: false,
  isCreditCardUser: false,
}

const mapStateToProps = ({ ui }) => ({
  ...ui,
})

export default connect(mapStateToProps)(Header)
